function Footer() {
  return (
    <div className="w-full h-[60] bg-gray-100 flex justify-center py-2 text-sm font-light">
      Welcome to the UMMEH world, designed by Sheep Lover
    </div>
  );
}
export default Footer;
